var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routes.length > 0)?_c('nav',{staticClass:"vertical menu",attrs:{"id":"side-menu"}},_vm._l((_vm.routes),function(route){return _c('router-link',{key:route.name,attrs:{"to":{name: route.name},"tag":"li"}},[_c('a',[_c('i',{class:'icon icon-' + route.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("t")(route.label)))])])])}),1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a249b86a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideMenu.vue
// module id = null
// module chunks = 